import { cn } from "@/lib/utils";
import { ReactNode } from "react";

interface PageContainerProps {
  children: ReactNode;
  className?: string;
  fullHeight?: boolean;
  centered?: boolean;
  scrollable?: boolean;
  asList?: boolean;
}

export function PageContainer({
  children,
  className,
  fullHeight = true,
  centered = false,
  scrollable = false,
  asList = false,
}: PageContainerProps) {
  return (
    <div
      className={cn(
        "container mx-auto p-4",
        fullHeight && "h-full",
        centered && "flex min-h-screen items-center justify-center",
        scrollable && "overflow-auto",
        asList && "flex flex-col",
        className
      )}
    >
      {children}
    </div>
  );
} 